import { WSTable, WSTableItem } from "@wingspanhq/fe-component-library";
import { PayStatement } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import { getColumns } from "./columns";

type Props = {
  items: PayStatement[];
  loading?: boolean;
  /** Per-row PDF download; the entry is hidden for rows with no generated file. */
  onDownloadRow?: (item: PayStatement) => void;
  onRowOpen?: (id: string) => void;
};

export const TablePaystubs: React.FC<Props> = props => {
  const tableData = useMemo<WSTableItem<PayStatement>[]>(
    () => props.items.map(item => ({ id: item.id ?? "", data: item })),
    [props.items]
  );
  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<PayStatement>
      columns={columns}
      loading={props.loading}
      // Row selection is intentionally absent: there is no bulk pay-statement
      // endpoint to act on a selection, so checkboxes would lead nowhere.
      rowMenuActions={item => [
        {
          icon: "file",
          label: "View details",
          onClick: () => props.onRowOpen?.(item.id)
        },
        // The only export the API offers is the per-statement PDF, and only
        // once its vault file has been generated.
        ...(props.onDownloadRow && item.data.fileId
          ? [
              {
                icon: "download" as const,
                label: "Download paystub",
                onClick: () => props.onDownloadRow?.(item.data)
              }
            ]
          : [])
      ]}
      tableData={tableData}
      onRowClick={item => props.onRowOpen?.(item.id)}
    />
  );
};
